/* La Revivance — product page: delivery estimate, description "Read more", sticky add to cart. */
(function () {
  if (window.__lrProduct) return;
  window.__lrProduct = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var lang = document.documentElement.lang || 'en';

    /* 1. Delivery estimate, counted in business days from today */
    document.querySelectorAll('[data-lr-eta]').forEach(function (el) {
      var min = parseInt(el.dataset.min, 10);
      var max = parseInt(el.dataset.max, 10);
      if (!min || !max) return;
      function addBusinessDays(n) {
        var d = new Date();
        while (n > 0) {
          d.setDate(d.getDate() + 1);
          var day = d.getDay();
          if (day !== 0 && day !== 6) n--;
        }
        return d;
      }
      var fmt;
      try { fmt = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'short' }); }
      catch (e) { fmt = new Intl.DateTimeFormat('en', { day: 'numeric', month: 'short' }); }
      var range = fmt.format(addBusinessDays(min)) + ' – ' + fmt.format(addBusinessDays(max));
      el.textContent = (el.dataset.template || '[range]').replace('[range]', range);
    });

    /* 2. Long description: show the opening, then "Read more" */
    var i18n = document.querySelector('[data-lr-pdp-i18n]');
    var desc = document.querySelector('.product__info-container .product__description');
    if (desc && i18n && desc.scrollHeight > 330) {
      desc.classList.add('lr-desc', 'is-clamped');
      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'lr-desc__toggle';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = i18n.dataset.more;
      desc.insertAdjacentElement('afterend', toggle);
      toggle.addEventListener('click', function () {
        var clamped = desc.classList.toggle('is-clamped');
        toggle.textContent = clamped ? i18n.dataset.more : i18n.dataset.less;
        toggle.setAttribute('aria-expanded', clamped ? 'false' : 'true');
        if (clamped) desc.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      });
    }

    /* 3. Sticky add to cart on phones, once the real button has scrolled away */
    var bar = document.querySelector('[data-lr-sticky]');
    var mainBtn = document.querySelector('.product-form__submit');
    if (!bar || !mainBtn || !('IntersectionObserver' in window)) return;

    var stickyBtn = bar.querySelector('[data-lr-sticky-btn]');
    var meta = bar.querySelector('[data-lr-sticky-meta]');

    function sync() {
      var wrap = document.querySelector('[id^="price-template"]');
      var price = wrap && wrap.querySelector('.price');
      var amount = '';
      if (price) {
        var el = price.classList.contains('price--on-sale')
          ? price.querySelector('.price__sale .price-item--sale')
          : price.querySelector('.price__regular .price-item--regular');
        amount = el ? el.textContent.trim() : '';
      }
      var size = document.querySelector('variant-selects input[type="radio"]:checked');
      var parts = [];
      if (size) parts.push(size.value);
      if (amount) parts.push(amount);
      if (parts.length) meta.textContent = parts.join(' · ');
      stickyBtn.disabled = mainBtn.disabled;
      var label = mainBtn.querySelector('span');
      if (label && label.textContent.trim()) stickyBtn.textContent = label.textContent.trim();
    }

    var io = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', past);
      bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      if (past) sync();
    });
    io.observe(mainBtn);

    stickyBtn.addEventListener('click', function () { mainBtn.click(); });
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-selects')) setTimeout(sync, 400);
    });
  });
})();
